if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true,
        fade: true
    });


    $('.slider-images').slick({
        accessibility: true,
        fade: true,
        arrows: false,
        swipe:false,
        speed: 500,
        autoplaySpeed: 3000,
        dots: false,
        slidesToShow: 1,
        infinte:false,
        slidesToScroll: 1,
        adaptiveHeight: false,
    });

    $(".gallery-line__list").slick({
        arrows: true,
        dots: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots:true,
                    arrows:false,  
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });


})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('.container-navigation');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('.privary-navigation__item a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('.container-navigation');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});